import {downloadApk, goTo} from '@/utils';
import {EventType} from './const';
import {homePage} from '@/config';

type UnknownMessage = unknown;

interface GamePayload {
  event?: EventType;
}

interface GameMessageShape {
  source?: string;
  payload?: GamePayload;
}

export interface CreateGameMessageHandlerOptions {
  onShare?: () => void;
}

export function createGameMessageHandler(
  options: CreateGameMessageHandlerOptions = {},
) {
  const {onShare} = options;
  return function handleGameMessage(data: UnknownMessage) {
    if (typeof data === 'object' && data) {
      const msg = data as GameMessageShape;
      if (msg.source === 'game') {
        const {event} = msg.payload || {};
        switch (event) {
          case EventType.EXIT:
          case EventType.BACK: {
            goTo(homePage, {
              screen: 'Home',
            });
            break;
          }
          case EventType.SHARE: {
            onShare?.();
            break;
          }
          case EventType.DOWNLOAD_APP: {
            downloadApk();
            break;
          }
          case EventType.LOGIN: {
            goTo('Login');
            break;
          }
          default:
            break;
        }
      }
    }
  };
}
